import Button from 'components/_parts/atoms/button';
import Input from 'components/_parts/atoms/input';
import Label from 'components/_parts/atoms/label';
import { useFormik } from 'formik';
import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useDispatch } from 'react-redux';
import {
  HIT_CREATE_DIRECTORATE,
  HIT_DELETE_DIRECTORATE,
  HIT_UPDATE_DIRECTORATE,
} from 'redux/actions/organization';
import styled from 'styled-components';
import './index.scss';
import initialValues from './initialValues';
import validationSchema from './validationSchema';

const FullScreenOverlay = styled.div`
  position: fixed;
  height: 100%;
  width: 100%;
  right: 0;
  right: 0;
  top: 0;
`;

const ButtonMod = styled(Button)`
  width: 100%;
  width: 92px;
  height: 40px;
  float: right;
`;

function WorkerType(props) {
  const dispatch = useDispatch();
  const { t } = props;
  const formik = useFormik({
    initialValues,
    validationSchema: validationSchema({ t }),
    onSubmit: async (values) => {
      try {
        if (props.typeForm === 'edit') {
          dispatch({
            type: HIT_UPDATE_DIRECTORATE,
            payload: {
              data: {
                ...formik.values,
                directorate_id: formik.values.directorate_id,
              },
              id: props.ids,
            },
          });
        } else if (props.typeForm === 'create') {
          dispatch({
            type: HIT_CREATE_DIRECTORATE,
            payload: {
              ...formik.values,
            },
          });
        } else {
          dispatch({
            type: HIT_DELETE_DIRECTORATE,
            payload: {
              data: {
                directorate_id: props?.data?.directorate_id,
              },
              id: props.ids,
            },
          });
        }
        props.funcModal(false);
        formik.resetForm();
      } catch (error) {
        props.funcModal(false);
        formik.resetForm();
      }
    },
    onChange: (e) => {
      formik.setFieldValue(e.target.name, e.target.value);
    },
  });
  useEffect(() => {
    if (props.typeForm === 'edit' && props.data !== undefined) {
      formik.setValues({
        directorate_name: props?.data?.directorate_name || '',
        directorate_id: props?.data?.directorate_id || '',
      });
    }
  }, [props.typeForm, props.data]);

  useEffect(() => {
    if (props.modal && props.typeForm === 'create') {
      formik.resetForm();
    }
  }, [props.modal, props.typeForm]);

  return (
    <>
      {props.modal
        && createPortal(
          <>
            <FullScreenOverlay className="cs_modal-bg" />
            <div
              className="cs_modal-container-activity-type d-flex justify-content-between flex-column"
              ref={props.innerRef}
            >
              <Label
                className="text-center"
                typeLabel="label_modal"
                style={{
                  fontSize: '16px',
                }}
              >
                {`${props?.typeForm === 'edit' ? t('org.structure_view.modal.edit') : t('org.structure_view.modal.add')} ${t('wla.analytics.table.directorate')}`}
              </Label>
              <div className="cs_modal-worktype">
                <div>
                  <Input
                    isError={
                      formik.touched.directorate_name
                      && Boolean(formik.errors.directorate_name)
                    }
                    validateMessage={formik.errors.directorate_name}
                    type="text"
                    name="directorate_name"
                    onChange={formik.handleChange}
                    value={formik?.values?.directorate_name}
                    placeholder={t('company.directorate_name')}
                  />
                </div>
              </div>
              <div className="d-flex justify-content-end">
                <ButtonMod
                  func={(e) => {
                    formik.handleSubmit(e);
                    setTimeout(() => {
                      props.funcId(null);
                    }, 1000);
                  }}
                >
                  {t('board.save')}
                </ButtonMod>
              </div>
            </div>
          </>,
          document.getElementById('direcotrate_list'),
        )}
    </>
  );
}

export default WorkerType;
